import { useGateValue } from '@statsig/react-bindings';

export const LANE_BOOKING_GATE = 'lane_planner_booking';

export function useLaneBookingGate(): boolean {
  return useGateValue(LANE_BOOKING_GATE);
}
